import { Component } from '@angular/core';

@Component({
	selector: 'app-reservation-list',
	templateUrl: './reservation-list.component.html',
	styleUrls: ['./reservation-list.component.css'],
})
export class ReservationListRefreshComponent {
	showRefresh = true;

	constructor() {}
}
